export interface AddressResult {
  tekst: string;
  data: { x: number; y: number };
}

export function validAddressResults(value: unknown): AddressResult[] {
  if (!Array.isArray(value)) return [];
  return value.filter((item): item is AddressResult => {
    return (
      !!item &&
      typeof item.tekst === 'string' &&
      !!item.data &&
      Number.isFinite(item.data.x) &&
      Number.isFinite(item.data.y) &&
      Math.abs(item.data.x) <= 180 &&
      Math.abs(item.data.y) <= 90
    );
  });
}

// Leaflet accepts nodes. User and API text must never be parsed as HTML.
export function addressPin(className: string, label: string, title: string): HTMLElement {
  const pin = document.createElement('div');
  pin.className = className;
  pin.title = title;
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  for (const [key, value] of Object.entries({
    width: '13',
    height: '13',
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    'stroke-width': '2.5',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
  }))
    svg.setAttribute(key, value);
  const path = document.createElementNS(svg.namespaceURI, 'path');
  path.setAttribute('d', 'M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z');
  const circle = document.createElementNS(svg.namespaceURI, 'circle');
  circle.setAttribute('cx', '12');
  circle.setAttribute('cy', '10');
  circle.setAttribute('r', '3');
  svg.append(path, circle);
  const span = document.createElement('span');
  span.textContent = label;
  pin.append(svg, span);
  return pin;
}

export function addressPopup(
  title: string,
  address: string,
  lat: number,
  lng: number,
): HTMLElement {
  const popup = document.createElement('div');
  popup.style.cssText =
    'font-family:system-ui,sans-serif;font-size:13px;line-height:1.4;padding:2px';
  const heading = document.createElement('strong');
  heading.textContent = title;
  const text = document.createElement('span');
  text.textContent = address;
  const gps = document.createElement('small');
  gps.textContent = `GPS: ${lat.toFixed(5)}, ${lng.toFixed(5)}`;
  popup.append(heading, document.createElement('br'), text, document.createElement('br'), gps);
  return popup;
}
